<template>
    <section class="gen-form-container" style="flex-grow: 1">
      <div class="gen-form-box">
        <div class="gfb-title">
          <h3>File manager</h3>
          <p>Max upload size: {{ formatFileSize(stores.auth.environment.maxUpload) }}</p>
        </div>
        <div class="gf-row">
          <label>Create Dir</label>
          <FormInput placeholder="Folder name" v-model="form.folderName" />
          <button type="button" @click.prevent="createDir">Create</button>
        </div>
        <div class="gf-row">
          <label>File Upload</label>
          <FormUpload placeholder="Input field" v-model="form.file" @update:modelValue="uploadFile" />
        </div>
        <div class="gf-row">
          <label>Files Upload</label>
          <FormUpload placeholder="Input field" v-model="form.files" @update:modelValue="uploadFile" multiple />
        </div>
        <div class="gf-row">
          <label>Folder Upload</label>
          <FormUpload placeholder="Input field" v-model="form.folder" @update:modelValue="uploadFile" folder />
        </div>

        <FileList :parent="parent" @openDir="openDir" ref="fileList" />
      </div>
    </section>
</template>

<script>
import api from "@/Util/api";

export default {
  data: ()=>({
    form: {
      file: null,
      files: null,
      folder: null,
      folderName: "",
    },
    parent: null,
  }),
  methods: {
    formatFileSize(bytes) {
      bytes=bytes || 0;
      var suffixes=["B", "kiB", "MiB", "GiB", "TiB"];
      var index=0;
      while(bytes>=1024 && index<suffixes.length-1) {
        bytes/=1024;
        index++;
      }
      return bytes.toFixed(0)+" "+suffixes[index];
    },
    async uploadFile(files) {
      for(var file of files) {
        var fileDb=api.create("File");
        fileDb.type="File";
        fileDb.parent=this.parent?.uuid || null;
        await fileDb.save();
        await fileDb.upload(file);
      }
      this.$refs.fileList.loadFiles();
    },
    async createDir() {
      var fileDb=api.create("File");
      fileDb.type="Folder";
      fileDb.filename=this.form.folderName;
      fileDb.parent=this.parent?.uuid || null;
      await fileDb.save();
      this.$refs.fileList.loadFiles();
    },
    openDir(file) {
      this.parent=file || null;
    },
  },
  created() {
  },
}
</script>
